import { useEffect, useRef } from "react";
import { s } from "../lib/constants";

function HighlightedQuestion({ text, otherName }) {
  if (!otherName || otherName === "them") return <span>{text}</span>;
  const parts = text.split(otherName);
  return (
    <>
      {parts.map((part, i) => (
        <span key={i}>
          {part}
          {i < parts.length - 1 && (
            <span style={styles.nameHighlight}>{otherName}</span>
          )}
        </span>
      ))}
    </>
  );
}

export default function QuestionsScreen({ currentQ, questions, personId, inputVal, setInputVal, onSubmit, otherName }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) textareaRef.current.focus();
  }, [currentQ]);

  function handleKeyDown(e) {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) onSubmit();
  }

  return (
    <div style={s.step}>
      <p style={s.eyebrow}>question {currentQ + 1} of {questions.length} — person {personId}</p>
      <p style={styles.questionText}>
        <HighlightedQuestion text={questions[currentQ].text} otherName={otherName} />
      </p>
      <p style={s.hint}>{questions[currentQ].hint}</p>
      <textarea
        ref={textareaRef}
        style={s.textarea}
        value={inputVal}
        onChange={e => setInputVal(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="write here… (Ctrl+Enter to continue)"
      />
      <button style={{ ...s.btnPrimary, alignSelf: "flex-end" }} onClick={onSubmit}>
        {currentQ + 1 < questions.length ? "Next" : "Submit"}
      </button>
    </div>
  );
}

const styles = {
  questionText: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "1.7rem",
    lineHeight: 1.35,
    color: "#e8e2d4",
    fontStyle: "italic",
    fontWeight: 300,
  },
  nameHighlight: {
    color: "#c8924a",
    fontStyle: "italic",
  },
};